import React, { useEffect } from 'react';
import { Container, Card, Button, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function ShipperMenu() {
  useEffect(() => {
    document.title = '出荷者メニュー | My Order System';
  }, []);

  return (
    <main>
      <Container className="my-4">
        <Card className="shadow-sm">
          <Card.Header as="h2" className="p-3">
            出荷者メニュー
          </Card.Header>
          <Card.Body className="p-4">
            <p className="lead">
              出荷担当者専用の機能一覧です。
            </p>
            <Row className="g-3 mt-3">
              <Col xs={12} md={6}>
                <Link
                  to="/shipper/order-processing"
                  className="btn w-100 shadow-sm text-white fw-bold"
                  style={{ backgroundColor: '#24639c' }}
                >
                  受注処理
                </Link>
              </Col>
              <Col xs={12} md={6}>
                 <Link
                  to="/history"
                  className="btn btn-outline-secondary w-100 shadow"
                >
                  全注文履歴
                </Link>
              </Col>
              <Col xs={12} md={4}>
                <Link
                  to="/csv-import"
                  className="btn btn-outline-secondary w-100 shadow"
                >
                  送り状No.データ取込
                </Link>
              </Col>
              <Col xs={12} md={4}>
                 <Link
                  to="/manual-shipment"
                  className="btn btn-outline-secondary w-100 shadow"
                >
                  送り状No.手入力
                </Link>
              </Col>
              <Col xs={12} md={4}>
                 <Link
                  to="/shipper-all-history"
                  className="btn btn-outline-secondary w-100 shadow"
                >
                  イレギュラー対応用全注文履歴
                </Link>
              </Col>
            </Row>
            <hr className="my-4" />
            <Link to="/mainmenu">
              メインメニューに戻る
            </Link>
          </Card.Body>
        </Card>
      </Container>
    </main>
  );
}

export default ShipperMenu;
